//

type Insight = {
  title: string;
  subtitle: string;
  icon: string;
  learnMore: boolean;
  modalText?: string;
};
const INSIGHTS_DATA: Insight[] = [
  {
    title: "home.bookyourperfectaccommodation.insights_data.instantandeasybookingstitle",
    subtitle: "home.bookyourperfectaccommodation.insights_data.instantandeasybookingssubtitleone",
    // "home.bookyourperfectaccommodation.insights_data.instantandeasybookingssubtitletwo"
    icon: "fast-and-easy-bookings-insight",
    learnMore: false,
  },
  {
    title: "home.bookyourperfectaccommodation.insights_data.lowestpriceguaranteetitle",
    subtitle: "home.bookyourperfectaccommodation.insights_data.lowestpriceguaranteesubtitle",
    icon: "expert-assistance-insight",
    learnMore: true,
  },
  {
    title: "home.bookyourperfectaccommodation.insights_data.assistance24x7title",
    subtitle: "home.bookyourperfectaccommodation.insights_data.assistance24x7subtitle",
    icon: "verified-listings-insight",
    learnMore: false,
  },
  {
    title: "home.bookyourperfectaccommodation.insights_data.verifiedlistingstitle",
    subtitle: "home.bookyourperfectaccommodation.insights_data.verifiedlistingssubtitle",
    icon: "price-match-guarantee-insight",
    learnMore: false,
  },
];

export default INSIGHTS_DATA;
